module.exports = __webpack_public_path__ + "static/media/atajos.83832520.png";